// import Message from './Message';
// import Progress from './Progress';
// import axios from 'axios';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';

// import { extractValue } from '../utils';

const MultipleFilesUpload = ({setFiles, PreviousFiles}) => {
    MultipleFilesUpload.propTypes = {
        setFiles: PropTypes.func,
        PreviousFiles: PropTypes.array,
    };
    // const [files, setFiles] = useState('');
    const [filesName, setFilesName] = useState('Choisir les fichiers pdf, .doc, .docx, .rtf, .txt (Taille max. : 5 MB)');

    // const [uploadedFiles, setUploadedFiles] = useState({});
    // const [message, setMessage] = useState('');
    // const [uploadPercentage, setUploadPercentage] = useState(0);

    const onChange = (e) => {
        const filesArray = Array.from(e.target.files);
        console.log(e.target.files[0] , 'hhh',e.target.files, 'aaaa', filesArray, setFilesName);
        setFiles([...PreviousFiles, ...filesArray ]);
        // * the probleme with this is that it wont update (no render will happens)
        // setFilesName(extractValue([...PreviousFiles, ...filesArray ], 'name')?.join(' ,') ?? '');
    };

    // useEffect(() => {
    //     setFilesName(extractValue(PreviousFiles, 'name')?.join(' ,'));
    // }, [PreviousFiles]);

    return (
        <Fragment>
            <form >
                <div
                    className='UploadContainer'
                    onChange={onChange}
                    style={{cursor:'pointer'}}
                >
                    <input
                        type='file'
                        className='custom-file-input'
                        id='customFiles'
                        accept=".pdf,.doc,.docx"
                        onChange={onChange}
                        multiple
                        readOnly
                    />
                    <label
                        className='custom-file-label'
                        htmlFor='customFiles'
                    >
                        {filesName}
                    </label>
                </div>

                {/* <Progress percentage={uploadPercentage} />

        { <input
          type='submit'
          value='Upload'
          className='btn btn-primary btn-block mt-4'
        /> } */}
            </form>
        </Fragment>
    );
};
export default MultipleFilesUpload;
